module.exports = __webpack_public_path__ + "static/slider3_mobile-bc1d7e45be66b420bd504b2b1200cbd6.png";